import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

const InfoBanner = ({ image, title, url }) => {
  if (!title) return null;

  return (
    <section className="info-banner">
      <div className="container">
        {image && (
          <div
            className="info-banner__image"
            style={{
              backgroundImage: `url(${image})`,
            }}
          >
            <img src={image} alt={title} />
            {url && (
              <Link className="d-md-none" to={url}>
                <img
                  src={require("assets/icons/arrow-right--new.svg").default}
                  alt=""
                />
              </Link>
            )}
          </div>
        )}
        <h3>{title}</h3>
        {url && (
          <Link className="d-none d-md-flex" to={url}>
            <img
              src={require("assets/icons/arrow-right--new.svg").default}
              alt=""
            />
          </Link>
        )}
      </div>
    </section>
  );
};

export default InfoBanner;
